import * as Sentry from "@sentry/react";

export interface ErrorToastOptions {
  title?: string;
  description: string;
}

export function captureErrorAndToast(
  error: unknown,
  toastFn: (options: { title?: string; description: string; variant?: "destructive" }) => void,
  toastOptions: ErrorToastOptions
) {
  // Capture error to Sentry
  Sentry.captureException(error);
  
  // Show toast to user
  toastFn({
    title: toastOptions.title,
    description: toastOptions.description,
    variant: "destructive"
  });
}